// Module
var code = "<div class=\"card-content\"> <h2 class=\"alert-name\"></h2> <div class=\"header\"></div> </div> <div class=\"form-container\"></div> ";
// Exports
export default code;